const sortDirection = {
    asc: "asc",
    desc: "desc",
};

export default sortDirection;
